export var FieldTestingTaskType;
(function (FieldTestingTaskType) {
    FieldTestingTaskType["MidTermInspection"] = "Mid-term inspection";
    FieldTestingTaskType["AnnualInspection"] = "Annual inspection";
    FieldTestingTaskType["CertifiedFieldTest"] = "Certified field test";
    FieldTestingTaskType["GmaxTest"] = "Gmax test";
})(FieldTestingTaskType || (FieldTestingTaskType = {}));
//# sourceMappingURL=fieldTestingTaskType.enum.js.map